import { create } from 'zustand';

type Panel = 'tasks' | 'chat' | 'notes';

interface AppStore {
  activePanel: Panel;
  setActivePanel: (panel: Panel) => void;
  isOnboardingComplete: (userId: string) => boolean;
  completeOnboarding: (userId: string) => void;
}

export const useAppStore = create<AppStore>(() => ({
  activePanel: (localStorage.getItem('activePanel') as Panel) || 'chat',
  setActivePanel: (panel) => {
    localStorage.setItem('activePanel', panel);
    useAppStore.setState({ activePanel: panel });
  },
  isOnboardingComplete: (userId: string) =>
    localStorage.getItem(`onboarding_complete_${userId}`) === 'true',
  completeOnboarding: (userId: string) => {
    localStorage.setItem(`onboarding_complete_${userId}`, 'true');
  },
}));
